import React from 'react';
import styles from '@/styles/components/ScreenerPurposeElement.module.css';

export type ScreenerPurposeElementData = Omit<
  ScreenerPurposeElementInnerData,
  'isFullHeight'
>;

interface ScreenerPurposeElementInnerData {
  isFullHeight: boolean;
  purposeTitle: string;
  purposeText: string;
}

export const ScreenerPurposeElement: React.FC<
  ScreenerPurposeElementInnerData
> = props => {
  return (
    <div className={styles.purposeWrapper}>
      <div
        className={
          props.isFullHeight
            ? styles.fullHeightPurposeContainer
            : styles.purposeContainer
        }
      >
        <span className={styles.purposeTitle}>{props.purposeTitle}</span>
        <span> </span>
        <span className={styles.purposeText}>{props.purposeText}</span>
      </div>
    </div>
  );
};
